import { GET } from "@/api/client";
import { TResponse } from "@/api/types";
import { useQuery } from "@tanstack/react-query";
import { AcceptanceStatus } from "../../types";

export const useGetHospitalsResource = (requestId: string) => {
  return useQuery<TResponse<ResourceStatusItem>>({
    queryKey: [`/transfer/requests/${requestId}/resources/all`],
    queryFn: () => GET(`/transfer/requests/${requestId}/resources/all`),
  });
};

export interface OperationAvailability {
  operCode: string;
  isAvailable: boolean;
}

export interface EquipmentAvailability {
  equipCode: string;
  stdEquip: number;
  rltmEquip: boolean;
}

export interface BedAvailability {
  bedCode: string;
  rltmPastBed: number;
  stdPastBed: number;
  rltmCurrentBed: number;
  stdCurrentBed: number;
}

export interface HospitalResource {
  hospitalCode: string;
  hospitalName: string;
  ranking: number;
  restTime: number;
  restDistance: number;
  o001Transfer: number;
  o001Svdss: number;
  operations: OperationAvailability[];
  equipments: EquipmentAvailability[];
  beds: BedAvailability[];
}

export interface ResourceStatusItem {
  operations: string[];
  equipments: string[];
  beds: string[];
  hospitalResourceResponse: HospitalResource[];
}

export const useGetTransferInfo = (requestId: string) => {
  return useQuery<TResponse<TransferRequestData>>({
    // 로그인 기능 완성 후 hosiptalCode 제거
    queryKey: [`/transfer/requests/${requestId}/info`],
    queryFn: () =>
      GET(`/transfer/requests/${requestId}/info`, { hospitalCode: "A1300002" }),
  });
};

export interface TransferRequestData {
  requestStatus: AcceptanceStatus;
  requestTime: string; // 또는 Date (받는 데이터 포맷에 따라 다름)
  decisionTime: string; // 또는 Date
  transferTime: string; // 또는 Date
  managerName: string;
  managerPhone: string;
  transferPosition: string;
  restTime: number;
  restDistance: number;
}

export const useGetOperationInfo = (requestId: string) => {
  return useQuery<TResponse<OperationInfo[]>>({
    // 로그인 기능 완성 후 hosiptalCode 제거
    queryKey: [`/transfer/requests/${requestId}/resources/operation`],
    queryFn: () =>
      GET(`/transfer/requests/${requestId}/resources/operation`, {
        hospitalCode: "A1300002",
      }),
  });
};

export interface OperationInfo {
  operationCode: string;
  department: string;
  doctorName: string;
  phoneNumber: string;
  workTime: string;
  isAvailable: boolean;
}

export const useGetICUResource = (hospitalCode: string) => {
  return useQuery<TResponse<ICUResource>>({
    // 로그인 기능 완성 후 hosiptalCode 제거
    queryKey: [`/resource/icu`],
    queryFn: () =>
      GET(`/resource/icu`, {
        hospitalCode,
      }),
  });
};

export interface BedCounts {
  o017: number;
  o018: number;
  o009: number;
  o008: number;
  o006: number;
  o015: number;
  o011: number;
  o013: number;
  o007: number;
  o012: number;
  o016: number;
}

export interface ICUResource {
  hospitalCode: string;
  hospitalName: string;
  stdPastBeds: BedCounts;
  rltmPastBeds: BedCounts;
  stdCurrentBeds: BedCounts;
  rltmCurrentBeds: BedCounts;
}
